export default __webpack_public_path__ + "static/media/private-profile-icon.04b03590.svg";